import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { CalculatedValueDataEntity } from '../../../../../models/data-entities';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-calculate-value-data-entity-view',
    templateUrl: './calculate-value-data-entity-view.component.html',
    styleUrls: ['./calculate-value-data-entity-view.component.css'],
    standalone: false
})
export class CalculateValueDataEntityViewComponent
  extends DataEntityViewComponent
  implements OnInit {
  entity: CalculatedValueDataEntity;
  templateForPermitForm: boolean = false;         // Added by Vipul on 19/12/2025

  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context : WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
    // Started by Vipul on 19/12/2025
  layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 19/12/2025
  }

  ngOnInit() {
    if (this.entity && !this.entity.formattedValue) {
      this.entity.formattedValue = '';
    }
  }

    // added by Deepak 13-05-2026
  getEntityLabelText(): string {
    if (!this.entity) {
      return '';
    }
  
    let label = this.entity.label || '';
  
    // // replicate required indicator
    // if (this.entity.isRequired) {
    //   label = `${label} *`;
    // }
  
    return label;
  }
  // end by Deepak 13-05-2026
}
